module.exports = __webpack_public_path__ + "img/yosheng.4f9a1a5c.png";